import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import style from './WidgetLauncher.scss';

export default class WidgetLauncher extends React.Component {

    render() {

        const contentDisplayed = this.props.isDisplayed;

        return (
            <div className="amt-widget-row">
                <style>
                    {style.toString()}
                </style>
                <div className="amt-widget-toggle" onClick={this.props.onClick}>
                    {contentDisplayed ?
                        <button className="amt-destroy-widget">
                            <FontAwesomeIcon icon="times"/>
                        </button> :
                        <button className="amt-render-widget">
                            translate
                        </button>
                    }
                </div>
            </div>
        );
    }
}